import React from 'react';
import { User } from '../../types';
import SpaceDefenderGame from './SpaceDefenderGame';
import KeyBeatsGame from './KeyBeatsGame';
import PictureSpellGame from './PictureSpellGame';
import NumberNinjaGame from './NumberNinjaGame';
import MemoryFlashGame from './MemoryFlashGame';
import StoryBuilderGame from './StoryBuilderGame';
import BlockMinerGame from './BlockMinerGame';
import ObbyRunGame from './ObbyRunGame';

// Games shared by the student and guest game hubs. `id` is also the
// game_name their scores are saved under.
export interface CatalogGame {
  id: string;
  title: string;
  icon: string;
  color: string;
  skill: string;
  description: string;
  subtitle: string;
  featured?: boolean; // shown at the very start of the game hub
  render: (user?: User) => React.ReactNode;
}

export const CATALOG_GAMES: CatalogGame[] = [
  {
    id: 'block-miner', title: 'Block Miner', icon: '⛏️', color: 'green', skill: 'Accuracy', featured: true,
    description: 'Mine blocks, craft treasures and stop night-time monsters across 10 worlds -- all by typing!',
    subtitle: 'Blocky adventure: type a block\'s word to mine it, and monsters\' words to stop them.',
    render: user => <BlockMinerGame user={user} />,
  },
  {
    id: 'obby-run', title: 'Obby Run', icon: '🏃', color: 'blue', skill: 'Speed', featured: true,
    description: 'Jump across 10 worlds of floating platforms before they crumble, and unlock new runners!',
    subtitle: 'Obstacle course: type the next platform\'s word to jump to it.',
    render: user => <ObbyRunGame user={user} />,
  },
  {
    id: 'space-defender', title: 'Space Defender', icon: '🚀', color: 'purple', skill: 'Accuracy',
    description: 'Blast alien ships by typing the words they carry before they reach your base.',
    subtitle: 'Accuracy drill: lock on with the first letter, then finish the word to fire.',
    render: user => <SpaceDefenderGame user={user} />,
  },
  {
    id: 'key-beats', title: 'Key Beats', icon: '🎵', color: 'red', skill: 'Rhythm',
    description: 'Play real songs -- from Twinkle Twinkle to Für Elise -- one key per note. 16 songs to unlock!',
    subtitle: 'Rhythm drill: press each lane\'s key as its note reaches the line to play the melody.',
    render: user => <KeyBeatsGame user={user} />,
  },
  {
    id: 'picture-spell', title: 'Picture Spell', icon: '🐝', color: 'orange', skill: 'Spelling',
    description: 'See a picture, spell the word. From cat to crocodile!',
    subtitle: 'Spelling drill: type the word that matches each picture.',
    render: user => <PictureSpellGame user={user} />,
  },
  {
    id: 'number-ninja', title: 'Number Ninja', icon: '🥷', color: 'green', skill: 'Number Row',
    description: 'Slice through math problems using the number keys.',
    subtitle: 'Number-row drill: type each answer before time runs out.',
    render: user => <NumberNinjaGame user={user} />,
  },
  {
    id: 'memory-flash', title: 'Memory Flash', icon: '🧠', color: 'blue', skill: 'Focus',
    description: 'A word flashes and vanishes -- can you type it from memory?',
    subtitle: 'Focus drill: read once, then type it without looking back.',
    render: user => <MemoryFlashGame user={user} />,
  },
  {
    id: 'story-builder', title: 'Story Builder', icon: '📖', color: 'red', skill: 'Punctuation',
    description: 'Type a silly story sentence by sentence to build your own comic strip.',
    subtitle: 'Capitals & punctuation drill: every Shift, comma and quote counts.',
    render: user => <StoryBuilderGame user={user} />,
  },
];
